import { AppState } from 'mk2/reducers';
import {
    initialListOfForumsPageState,
    initialTopicsListState,
    ListOfForumsPageState,
    TopicsListState,
} from './ListOfForums.reducers';

export const getListOfForumsState = (state: AppState): ListOfForumsPageState =>
    state.containers.forum.listOfForums || initialListOfForumsPageState;

export const getListOfForumsTopicsListState = (state: AppState): TopicsListState => {
    const listOfForumsState = getListOfForumsState(state);
    return listOfForumsState.topics
        ? listOfForumsState.topics
        : initialTopicsListState;
};
